import React from 'react'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import VibalLogo from '../../../assets/cert/CertificateVibalLogoEdited.png'
import CertBackground from '../../../assets/cert/CertificateBackground.png'
import Signature from '../../../assets/cert/CertificateSignatureEdited.png'
import moment from 'moment'

import { CapitalizeEveryFirstLetter } from '../../../functions'

// const styles = StyleSheet.create({
//     page: {
//       flexDirection: 'row',
//       backgroundColor: '#E4E4E4',
//     },
//     section: {
//       margin: 10,
//       padding: 10,
//       flexGrow: 1
//     }
// });

Font.register({
    family: 'Open Sans',
    fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
    ]
});

const styles = StyleSheet.create({
    pageBackground: {
      position: 'absolute',
      minWidth: '100%',
      minHeight: '100%',
      display: 'block',
      height: '100%',
      width: '100%',
    },
    signatureStyle: {
        position: 'absolute',
        bottom: '5mm',
        left: '43%',
        width: '4cm'
    }
})

Font.registerHyphenationCallback(word => {
    return([word])
})

const PDFGenerator = (data) => {
    console.log("CREATING PDF...")

    return (
    <Document>
      <Page 
        size="A4" 
        orientation="landscape"
        // ruler
        style={{
            background: `url(${CertBackground})` 
        }}
      >
        <Image src={CertBackground} style={styles.pageBackground} />
        <View 
            style={{
                paddingTop: "2cm"
            }}
        >
          <Image
            src={VibalLogo}
            style={{
                width: "30%",
                margin: 'auto'
            }}
          />
        </View>
        <View 
            style={{
                textAlign: 'center',
                fontWeight: '1000',
                paddingTop: '18mm'
            }}
        >
            <Text
                style={{
                    fontSize: '12mm',
                    fontWeight: 1000,
                    color: '#0099cc',
                    fontFamily: 'Open Sans'
                }}
            >CERTIFICATE OF PARTICIPATION</Text>
        </View>
        <View 
            style={{
                textAlign: 'center',
                paddingTop: '4mm'
            }}
        >
            <Text
                style={{
                    fontSize: '5mm',
                    color: 'gray'
                }}
            >is given to</Text>
        </View>
        <View 
            style={{
                textAlign: 'center',
                paddingTop: '5mm'
            }}
        >
            <Text
                style={{
                    fontSize: '12mm',
                    color: '#0099cc',
                }}
            >{data.name? data.name : 'Participant Name'}</Text>
            <View 
                style={{
                    borderBottom: '1pt solid gray',
                    width: '80%',
                    margin: 'auto',
                    paddingTop: '2mm'
                }}
            >
            </View>
        </View>
        <View 
            style={{
                textAlign: 'center',
                paddingTop: '5mm',
            }}
        >
            <Text
                style={{
                    fontSize: '5mm',
                    color: 'gray'
                }}
            >for actively participating in</Text>
            <Text
                style={{
                    fontSize: '5mm',
                    color: 'gray',
                    paddingTop: '1mm'
                }}
            >
                Vibal's Webinar on the topic
            </Text>
        </View>
        <View
            style={{
                paddingTop: '4mm',
                textAlign: 'center'
            }}
        >
            <Text style={{ fontSize: '8mm', color: '#0099cc', paddingLeft: '12mm', paddingRight: '12mm' }}>"{data.topic? data.topic : 'Training Title'}"</Text>
        </View>
        <View
            style={{
                paddingTop: '4mm',
                textAlign: 'center'
            }}
        >
            <Text style={{ fontSize: '5mm', color: 'gray' }}>held on the {data.date_attended? data.date_attended : moment().format(`Do of MMMM, YYYY`)}</Text>
        </View>
        <View 
            style={{
                textAlign: 'center',
                paddingTop: '35mm'
            }}
        >
            <Image src={Signature} style={styles.signatureStyle}/>
            <Text style={{ color: '#4d4d4d' }}>Ms. Vina Ross Sarah B. Sunga</Text>
            <Text style={{ color: 'gray', fontSize: '5mm', fontStyle: 'italic' }} >Head, Teaching and Learning</Text>
            <Text style={{ color: '#4d4d4d'}} >Vibal Group</Text>
        </View>
      </Page>
    </Document>
    ) 
}

export default PDFGenerator